import styled from "styled-components";
import * as PropTypes from "prop-types";
import { Modal } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import ActionButton from "basicComponents/ActionButton/ActionButton";

export default function TreatmentStepPopUp({ visible, onClose, treatment }) {
  return (
    <Modal open={visible}>
      <Container>
        <Wrapper>
          {treatment && <div>{treatment.message}</div>}
          <CenterDiv>
            <ActionButton onClick={onClose}>
              <FormattedMessage {...GlobalMessages.dismiss} />
            </ActionButton>
          </CenterDiv>
        </Wrapper>
      </Container>
    </Modal>
  );
}

TreatmentStepPopUp.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  treatment: PropTypes.object,
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CenterDiv = styled.div`
  margin-top: ${({ theme }) => theme.margin}rem;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  max-width: 30rem;
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.padding}rem;
`;
